import { gql } from '@apollo/client';
import { entitlementDetails } from './fetch-cloud-site-products';

export const fetchProductsForOrganization = gql`
  ${entitlementDetails}
  query fetchCloudSiteProductAppAndSubscriptionsForOrganizationPPC(
    $organizationId: String
    $transactionAccountId: String
    $filterOptions: [FilterOption]
  ) {
    productsForOrganizationPPC(
      organizationId: $organizationId
      transactionAccountId: $transactionAccountId
      filterOptions: $filterOptions
    ) {
      ...entitlementDetail
    }
  }
`;
